import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";

export class Genre extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Tag' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'string?' })
    color?: string;

    @JsonProperty({ type: 'string' })
    slug: string;

}



// WEBPACK FOOTER //
// ./src/api/src/models/genre.ts